import { useSearchParams } from 'react-router-dom';

import { FetchError } from 'exceptions/FetchError';
import { useMediaServer } from 'hooks/useMediaServer';

export default function useSitePlan(
  baseUrl: string,
  baseUrlParamReplace = '%page_number%'
): {
  content?: string;
  error?: FetchError;
  pageNumber: number;
} {
  const PAGE_PARAM = 'p';
  const DEFAULT_PARAM_VALUE = '1';

  const [params] = useSearchParams();
  const pageNumber = params.get(PAGE_PARAM) || DEFAULT_PARAM_VALUE;
  const { content, error } = useMediaServer(
    baseUrl.replace(baseUrlParamReplace, pageNumber)
  );

  return {
    content,
    error,
    pageNumber: +pageNumber,
  };
}
